/* ==========================================================
   NAO Cart Drawer — STABLE (single init) — FIXED
   - Auto-open after add-to-cart (apps included)
   - Refresh on change/update
   - Trash remove
   - Mystery jersey meta (taille/boite/exclu) supported
   - CLEAN TITLES in drawer (cut after 2025/26)
   ========================================================== */
(() => {
  'use strict';

  if (window.__NAO_CART_DRAWER_STABLE__) return;
  window.__NAO_CART_DRAWER_STABLE__ = true;

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  /* ---------- Config ---------- */
  const ELIGIBLE_KEYWORD = String(drawer.dataset.eligibleKeyword || 'coque').toLowerCase();
  const PROMO_PAIR = parseInt(drawer.dataset.promoQty || '2', 10);
  const GLASS_HANDLE = 'verre-trempe-de-protection';

  /* ---------- DOM refs ---------- */
  const els = {
    items: drawer.querySelector('#cd-items'),
    total: drawer.querySelector('#cd-total'),
    count: drawer.querySelector('#cd-count'),
    progressText: drawer.querySelector('#cd-progress-text'),
    progressBar: drawer.querySelector('#cd-progress-bar'),
    ctaTotal: drawer.querySelector('#cd-cta-total'),
    glassSection: drawer.querySelector('#cd-glass'),
    glassSwitch: drawer.querySelector('#cd-glass-switch'),
    glassImg: drawer.querySelector('#cd-glass-img'),
  };

  /* ---------- Helpers ---------- */
  const moneyFmt = (window.Shopify && Shopify.money_format) ? Shopify.money_format : null;
  const fmt = (cents) => {
    const c = Number(cents || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && moneyFmt) {
      return Shopify.formatMoney(c, moneyFmt);
    }
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100);
  };

  const norm = (s) => {
    try {
      return (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    } catch (e) {
      return (s || '').toString().toLowerCase();
    }
  };

  const escapeHtml = (s) => (s || '').toString().replace(/[&<>"']/g, (m) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[m]));

  const cleanTitle = (title) => {
    let t = (title || '').toString();

    /* Nettoyage de base */
    t = t.replace(/Coque football\s*/gi, '');
    t = t.replace(/Coque Smartphone\s*/gi, '');
    t = t.replace(/Coque\s*/gi, '');

    t = t.replace(/personnalis[ée]?\s*nom\s*num[ée]ro/gi, '');
    t = t.replace(/personnalis[ée]?/gi, '');

    t = t.replace(/\s*[-–—]?\s*2[èe]me\s*coque\s*-?50%/gi, '');
    t = t.replace(/\s*[-–—]?\s*iPhone\s*Samsung\s*Xiaomi\s*Redmi/gi, '');

    t = t.replace(/— —/g, '');
    t = t.replace(/– –/g, '');
    t = t.replace(/--/g, '');
    t = t.replace(/\s[-–—]\s/g, ' ');
    t = t.replace(/\s{2,}/g, ' ').trim();

    /* ✅ Coupe stricte après 2025/26 */
    const seasonMatch = t.match(/.*?2025\/26/i);
    if (seasonMatch && seasonMatch[0]) {
      t = seasonMatch[0].trim();
    }

    return t;
  };

  /* ---------- Drawer open/close ---------- */
  let lastActive = null;
  const focusableSel = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const open = () => {
    lastActive = document.activeElement || null;
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('drawer-open');

    const f = drawer.querySelector(focusableSel);
    if (f) setTimeout(() => f.focus(), 0);

    fetchCart();
  };

  const close = () => {
    if (drawer.contains(document.activeElement)) {
      try { document.activeElement.blur(); } catch (e) {}
    }
    drawer.classList.add('hidden');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('drawer-open');

    if (lastActive && document.contains(lastActive)) {
      try { lastActive.focus(); } catch (e) {}
    }
  };

  drawer.addEventListener('click', (e) => {
    if (e.target.matches('[data-close]') || e.target.closest('[data-close]')) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  /* ---------- Triggers ---------- */
  function bindCartTriggers(scope = document) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && !bubble.hasAttribute('data-open-cart')) bubble.setAttribute('data-open-cart', '');

    scope.querySelectorAll('[data-open-cart], a[href="/cart"], a[href^="/cart?"], .site-header__cart, .header__icon--cart, .cart-link')
      .forEach(el => {
        if (el.__nao_bound__) return;
        el.__nao_bound__ = true;

        el.addEventListener('click', (ev) => {
          if (el.tagName === 'A') ev.preventDefault();
          ev.stopPropagation();
          open();
        }, { passive: false });
      });
  }

  bindCartTriggers();
  document.addEventListener('shopify:section:load', (ev) => bindCartTriggers(ev.target));
  document.addEventListener('shopify:section:select', (ev) => bindCartTriggers(ev.target));

  /* ---------- Preview image from properties ---------- */
  const getPreviewImage = (item) => {
    const props = item.properties || {};
    const URL_RE = /^https?:\/\//i;
    const keysPriority = ['pplr', 'preview', '_preview', 'image', 'img', 'custom', 'personnal', 'personal', 'mockup'];

    for (const k in props) {
      const key = norm(k);
      const val = props[k];

      if (typeof val === 'string' && URL_RE.test(val) && keysPriority.some(sig => key.includes(sig))) return val;
      if (val && typeof val === 'object') {
        if (typeof val.src === 'string' && URL_RE.test(val.src)) return val.src;
        if (typeof val.url === 'string' && URL_RE.test(val.url)) return val.url;
      }
    }
    return item.image || '';
  };

  const getProp = (props, keys) => {
    const wanted = keys.map(norm);
    for (const k in props) if (wanted.includes(norm(k))) return props[k];
    return '';
  };

  const getFromOptionsWithValues = (item, nameCandidates) => {
    const set = Array.isArray(item.options_with_values) ? item.options_with_values : [];
    const wanted = nameCandidates.map(norm);
    for (const ov of set) {
      if (wanted.includes(norm(ov.name))) return ov.value || '';
    }
    return '';
  };

  const sizeFromItem = (item) => {
    const props = item.properties || {};
    const p = getProp(props, ['Taille', 'Size']) || getFromOptionsWithValues(item, ['Taille', 'Size']);
    if (p) return String(p).trim();
    if (item.variant_title) {
      const parts = String(item.variant_title).split('/').map(s => s.trim());
      const hit = parts.find(x => /\b(\d{1,2}\/\d{1,2}|3xl|xxl|xl|xs|s|m|l|ans|enfant|adulte)\b/i.test(x));
      if (hit) return hit;
    }
    return '';
  };

  const boxFromItem = (item) => {
    const props = item.properties || {};
    const p =
      getProp(props, ['Boîte', 'Boite', 'Avec boîte', 'Avec boite', 'Sans boîte', 'Sans boite', "Options d'emballage", "Option d'emballage"]) ||
      getFromOptionsWithValues(item, ["options d'emballage", "option d'emballage", 'Boîte', 'Boite']);
    if (p) return String(p).trim();
    if (item.variant_title) {
      const parts = String(item.variant_title).split('/').map(s => s.trim());
      const hit = parts.find(x => /(boite|boîte|emballage)/i.test(x));
      if (hit) return hit;
    }
    return '';
  };

  const cleanProps = (obj) => {
    const out = [];
    const URL_RE = /^https?:\/\//i;

    for (const k in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;

      const key = k || '';
      const val = obj[k];
      const lowKey = norm(key);

      const isTech = lowKey.startsWith('_') || lowKey.endsWith('_crop');
      const isUrl = typeof val === 'string' && URL_RE.test(val);

      if (isTech || isUrl) continue;
      if (val == null || String(val).trim() === '') continue;

      out.push({ key, value: val });
    }
    return out;
  };

  function renderMeta(item) {
    const props = item.properties || {};
    const title = norm(item.product_title || item.title || '');

    if (title.includes('maillot mystere') || title.includes('maillot mystère')) {
      const taille = sizeFromItem(item);
      const boite = boxFromItem(item);
      const exclu = getProp(props, ['Clubs à exclure', 'Club à exclure', 'Clubs a exclure', 'Club a exclure']);

      return [
        `TAILLE: ${taille || '—'}`,
        `OPTIONS D’EMBALLAGE: ${boite || '—'}`,
        exclu ? `CLUBS À EXCLURE: ${exclu}` : ''
      ].filter(Boolean).join('\n');
    }

    const cleaned = cleanProps(props);
    return cleaned.length ? cleaned.map(p => `${p.key}: ${p.value}`).join(' • ') : '';
  }

  /* ---------- Promo eligibility ---------- */
  const isEligible = (item) => {
    const t = norm(item.product_title || item.title || '');
    const pt = norm(item.product_type || '');
    const u = norm(item.url || '');

    return t.includes(ELIGIBLE_KEYWORD) || pt.includes(ELIGIBLE_KEYWORD) || u.includes(ELIGIBLE_KEYWORD);
  };

  function updatePromoProgress(cart) {
    if (!els.progressBar && !els.progressText) return;

    const eligibleQty = (cart.items || []).reduce((n, i) => n + (isEligible(i) ? (i.quantity || 0) : 0), 0);

    if (els.progressText) {
      if (eligibleQty >= PROMO_PAIR) {
        els.progressText.innerHTML = '<strong>Offre activée : -50% sur la 2ᵉ coque 🎉</strong>';
      } else {
        const need = Math.max(0, PROMO_PAIR - eligibleQty);
        els.progressText.innerHTML = `Ajoute ${need} coque${need > 1 ? 's' : ''} pour <strong>-50%</strong> sur la 2ᵉ`;
      }
    }

    if (els.progressBar) {
      const pct = (eligibleQty >= PROMO_PAIR) ? 100 : Math.min(100, (eligibleQty / PROMO_PAIR) * 100);
      els.progressBar.style.width = `${pct}%`;
    }
  }

  /* ---------- Cart fetch/render ---------- */
  function fetchCart() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        renderCart(cart);
        updatePromoProgress(cart);
        renderGlassUpsell(cart);
        return cart;
      })
      .catch(() => null);
  }

  function renderCart(cart) {
    if (!els.items) return;

    els.items.innerHTML = '';

    (cart.items || []).forEach(item => {
      const rawImg = getPreviewImage(item);
      const imgUrl = rawImg ? `${rawImg}${rawImg.includes('?') ? '&' : '?'}width=240` : '';
      const shortTitle = cleanTitle(item.product_title || item.title || '');

      let metaHTML = '';
      try { metaHTML = (renderMeta(item) || '').replace(/\n/g, '<br>'); } catch (e) { metaHTML = ''; }

      const card = document.createElement('article');
      card.className = 'cd-item';
      card.dataset.key = item.key;

      card.innerHTML = `
        <figure class="cd-thumb">
          <img src="${escapeHtml(imgUrl)}" alt="${escapeHtml(shortTitle)}" loading="lazy">
        </figure>

        <div class="cd-body">
          <div class="cd-row">
            <h4 class="cd-title">${escapeHtml(shortTitle)}</h4>

            <button class="cd-bin" type="button" aria-label="Supprimer">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 6h2v10h-2V9zm4 0h2v10h-2V9zM7 9h2v10H7V9z"></path>
              </svg>
            </button>
          </div>

          ${metaHTML ? `<div class="cd-itemmeta">${metaHTML}</div>` : ''}

          <div class="cd-meta">
            <span class="cd-qtytxt">Qté : <strong>${item.quantity || 1}</strong></span>
            <span class="cd-price">${fmt(item.final_line_price)}</span>
          </div>
        </div>
      `;

      els.items.appendChild(card);

      const bin = card.querySelector('.cd-bin');
      if (bin) {
        bin.addEventListener('click', () => {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(() => fetchCart());
        });
      }
    });

    if (els.total) els.total.textContent = fmt(cart.total_price || 0);
    if (els.ctaTotal) els.ctaTotal.textContent = fmt(cart.total_price || 0);
    if (els.count) els.count.textContent = cart.item_count || 0;
  }

  /* ---------- Upsell verre trempé ---------- */
  let glassProduct = null;

  const cartHasCoque = (cart) => (cart.items || []).some(i => isEligible(i));
  const cartHasGlass = (cart, glassProductId) => (cart.items || []).find(i => i.product_id === glassProductId);

  function fetchGlassProduct() {
    if (glassProduct) return Promise.resolve(glassProduct);
    return fetch(`/products/${GLASS_HANDLE}.js`, { cache: 'no-store' })
      .then(r => r.json())
      .then(p => (glassProduct = p))
      .catch(() => null);
  }

  function renderGlassUpsell(cart) {
    if (!els.glassSection) return;

    if (!cartHasCoque(cart)) {
      els.glassSection.hidden = true;
      return;
    }

    fetchGlassProduct().then(product => {
      if (!product) {
        els.glassSection.hidden = true;
        return;
      }

      const imgSrc = (product.images && product.images.length) ? product.images[0] : product.featured_image;
      if (els.glassImg && imgSrc) els.glassImg.src = imgSrc;

      const inCart = cartHasGlass(cart, product.id);
      const isOn = Boolean(inCart);

      if (els.glassSwitch) {
        els.glassSwitch.classList.toggle('is-on', isOn);
        els.glassSwitch.setAttribute('aria-pressed', isOn ? 'true' : 'false');

        els.glassSwitch.onclick = () => {
          if (!inCart) {
            const vid = product.variants && product.variants.length ? product.variants[0].id : null;
            if (!vid) return;
            const fd = new FormData();
            fd.append('id', vid);
            fd.append('quantity', 1);
            fetch('/cart/add.js', { method: 'POST', body: fd }).then(() => fetchCart());
          } else {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: inCart.key, quantity: 0 })
            }).then(() => fetchCart());
          }
        };
      }

      els.glassSection.hidden = false;
    });
  }

  /* ---------- AUTO OPEN after cart mutations ---------- */
  function urlMatchesCartMutation(url) {
    const u = String(url || '');
    return u.includes('/cart/add') || u.includes('/cart/change') || u.includes('/cart/update') || u.includes('/cart/clear');
  }

  if (!window.__NAO_FETCH_HOOKED__) {
    window.__NAO_FETCH_HOOKED__ = true;
    const _fetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const res = await _fetch(...args);

      try {
        const url = (args && args[0]) ? (typeof args[0] === 'string' ? args[0] : args[0].url) : '';
        if (urlMatchesCartMutation(url)) {
          if (String(url).includes('/cart/add')) setTimeout(open, 150);
          else setTimeout(fetchCart, 50);
        }
      } catch (e) {}

      return res;
    };
  }

  if (!window.__NAO_XHR_HOOKED__) {
    window.__NAO_XHR_HOOKED__ = true;

    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__nao_url = url;
      return _open.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function(body) {
      this.addEventListener('load', () => {
        try {
          const u = this.__nao_url || this.responseURL;
          if (urlMatchesCartMutation(u)) {
            if (String(u).includes('/cart/add')) setTimeout(open, 150);
            else setTimeout(fetchCart, 50);
          }
        } catch (e) {}
      });

      return _send.call(this, body);
    };
  }

  /* ---------- Public API ---------- */
  window.NAO_CART_DRAWER = { open, close, refresh: fetchCart };
  document.addEventListener('cart:open', open);
})();